import { render, staticRenderFns } from "./TransportOrderReportPrimaryDeliveryWarning.vue?vue&type=template&id=0359b0d6&scoped=true&lang=pug"
import script from "./TransportOrderReportPrimaryDeliveryWarning.vue?vue&type=script&lang=js"
export * from "./TransportOrderReportPrimaryDeliveryWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0359b0d6",
  null
  
)

export default component.exports